import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getBoardOverview,
  getBoardActivity,
  postBoardUpdate,
  duplicateSprint,
} from '@/lib/board-overview';
import { sprintKeys, backlogKeys } from './use-sprints';

export const boardOverviewKeys = {
  overview: (boardId: string) => ['board-overview', boardId] as const,
  activity: (boardId: string) => ['board-activity', boardId] as const,
};

export function useBoardOverview(boardId: string | undefined) {
  return useQuery({
    queryKey: boardOverviewKeys.overview(boardId ?? ''),
    queryFn: () => getBoardOverview(boardId!),
    enabled: !!boardId,
    staleTime: 15_000,
  });
}

export function useBoardActivity(boardId: string | undefined) {
  return useQuery({
    queryKey: boardOverviewKeys.activity(boardId ?? ''),
    queryFn: () => getBoardActivity(boardId!),
    enabled: !!boardId,
    staleTime: 15_000,
  });
}

export function usePostBoardUpdate(boardId: string) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (body: string) => postBoardUpdate(boardId, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: boardOverviewKeys.activity(boardId) });
      qc.invalidateQueries({ queryKey: boardOverviewKeys.overview(boardId) });
    },
  });
}

export function useDuplicateSprint(boardId: string) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (sprintId: string) => duplicateSprint(sprintId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: boardOverviewKeys.overview(boardId) });
      qc.invalidateQueries({ queryKey: sprintKeys.lists() });
      qc.invalidateQueries({ queryKey: backlogKeys.list(boardId) });
    },
  });
}
